import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Select } from '@ngxs/store';
import { get } from 'lodash';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';
import { BookmarksState } from 'src/app/bookmarks/state/bookmarks.state';

@Component({
  selector: 'app-view-content-warning',
  templateUrl: './view-content-warning.component.html',
  styleUrls: ['./view-content-warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ViewContentWarningComponent implements OnInit, OnDestroy {

  // ---------- Observables ----------
  @Select(BookmarksState.getSelectedBookmark)
  bookmark$: Observable<BookmarkModel>;

  shown = false;
  private ngUnsubscribe = new Subject();

  constructor(
    private changeRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.bookmark$
      .pipe(
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((bookmark) => {
        const tags: string[] = get(bookmark, 'tags', []);
        this.shown = tags.includes('complete anatomy');
        this.changeRef.markForCheck();
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  handleDismiss() {
    this.shown = false;
    this.changeRef.markForCheck();
  }

}
